import ApplePayButton from '@comp/ApplePayButton';
import { OnSubmit } from '@hooks/useOnSubmit';
import GooglePayButtonComponent from '../GooglePayButton';
import './PayButtons.scss';

export type PayInfo = {
  fee: string;
  clientName: string | undefined;
  agreementId: number | undefined;
  fullAmount: string;
  payAmount: string;
  merchant?: string;
  merchantHost?: string;
};

type PayButtonsProps = {
  payInfo: PayInfo;
  isApple: boolean;
  isGoogle: boolean;
  onSubmit: OnSubmit;
  nomadLife?: boolean;
};

const PayButtons = (props: PayButtonsProps) => {
  const { isApple, isGoogle, onSubmit, payInfo, nomadLife } = props;
  return (
    <div className="button-container">
      <div className="childOne">
        {isApple && (
          <ApplePayButton
            payInfo={payInfo}
            onSubmit={onSubmit}
            nomadLife={nomadLife}
          />
        )}
      </div>
      <div className="childTwo">
        {isGoogle && (
          <GooglePayButtonComponent
            payInfo={payInfo}
            onSubmit={onSubmit}
            nomadLife={nomadLife}
          />
        )}
      </div>
    </div>
  );
};

export default PayButtons;
